import TEXT from '../../DOM/text/TEXT.js';
import EL, { HTMLELEMENT } from '../../EL/EL.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
import { makeStruct } from '../../../enums/MODELS.js';
// Model Structure
export const spanAttr = makeAttrStruct([
    ['class'],
    ['name']
]);
export const spanData = makeDataStruct([
    ['text', ''],
    ['textGroup', ''],
    ['textKey', '']
]);
export const spanModel = makeStruct([
    ['attributes', spanAttr],
    ['data', spanData]
]);
// Simplified Model
export function span(text, className, textGroup, textKey) {
    return {
        attributes: spanAttr(className),
        data: spanData(text, textGroup, textKey)
    };
}
/** A SPAN Element */
export default class SPAN extends TEXT {
    constructor(node, model) {
        super(node, HTMLELEMENT.SPAN, model);
    }
}
export { EL };
